
/**
* @memberof rmOBA
* @ngdoc service
* @name rmUtils
* @description 
*   Commonly used Utility functions used throughout app
*/

rmOBA.factory('rmUtils', function () {

        var regexMap = {
            alpha: /^[a-zA-Z]+$/,
            num: /^([0-9]+)$/,
            alphaNum: /^[a-zA-Z0-9]*$/,
            alphaNumSpaces: /^[a-zA-ZÀ-ú0-9\-\s]+$/,
            email: /^[\w\-\+\~\'\&\/\=\?\^\{\}]+(\.[\w\-\+\~\'\&\/\=\?\^\{\}]+)*\@[\w\-]+((\.([\w\-]+))?)*(\.([a-zA-Z]){2,6}){1,2}$/,
            ukPhone: /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/,
            numberStartsWith9: /^(9[0-9]+)$/
        }

        return {

            /**
            * @memberof rmUtils
            * @function camelize
            * @desc Convert string with spaces into camelCase format
            * @param {string} str String variable top be camelized
            * @returns {string} camel case version of input string 
            */ 
            camelize: function(str) {
                return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
                    return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
                }).replace(/\s+/g, '');
            },

            /**
            * @memberof rmUtils
            * @function getRegex
            * @desc Map string value to a regex string value.
            * @param {string} str String variable to match
            * @returns {string} regular expression for human-readable string
            */ 
            getRegex: function(str) {
                if (str in regexMap) {
                    return regexMap[str];
                }
            },

            /**
            * @memberof rmUtils
            * @function tealiumTagOverlay
            * @desc Update data layer with new view tags and push to Tealium
            * @param {object} new_tags Object of new tags to push
            */ 
            tealiumTagOverlay: function(new_tags) {
                var key;

                if (typeof utag === 'object') {
                    // Function to invoke tealium call from JS i.e. overlay tracking and angular js apps.
                    for (key in new_tags) {
                        utag_data[key] = new_tags[key];
                    }
                    // console.log('Tealium track overlay: ', utag_data);
                    utag.view(utag_data);
                }
            }
        };
    });